import { render } from "./advantage.vue?vue&type=template&id=437d6848&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"

import "./advantage.vue?vue&type=style&index=0&id=437d6848&scoped=true&lang=css"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437d6848"]])

export default __exports__